import type { FC } from 'react';
import React from 'react';
import { InfoBox } from '@THC/components/InfoBox';
import { useStore } from 'zustand';

import { EnquiriesStore } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';

export const EnquirySelectionListLimitInfo: FC = () => {
	const hasMoreItems = useStore(EnquiriesStore, (state) => state.hasMoreItems);
	return hasMoreItems ? <InfoBox content={T.translate('enquiryList.limitInfoBox')} variant="info" /> : null;
};
